import { Flex, Grid, Text } from '@tremor/react';
import { useLoaderData } from 'react-router-dom';
import { AvailableConnector } from '@/types/Connectors';
import { ConnectorTitle } from '@/components/layouts/Connectors/ConnectorTitle/ConnectorTitle';
import { ConnectorListTile } from '@/components/layouts/Connectors/ConnectorListTile/ConnectorListTile';
import { AuthLoaderFunction } from '@/types/auth';
import { ConnectorsService } from '@/services/connectorsService';
import { useOrganizationStore } from '@/stores/organizationStore';

export function ConnectorsList() {
  const availableConnectors = useLoaderData() as AvailableConnector[];
  return (
    <Flex flexDirection="col" alignItems="start">
      <ConnectorTitle prefix={false}>Select connector to add</ConnectorTitle>
      <Grid style={{ width: '100%' }} numCols={3} className="gap-5 mt-5">
        {availableConnectors.length === 0 ? (
          <Flex>
            <Text>No connectors available</Text>
          </Flex>
        ) : (
          availableConnectors.map((connector) => (
            <ConnectorListTile
              isAdded={connector.isAdded}
              key={connector.id}
              name={connector.name}
              connectorName={connector.id}
            />
          ))
        )}
      </Grid>
    </Flex>
  );
}

export const ConnectorsListLoader: AuthLoaderFunction<AvailableConnector[]> = async ({
  request,
}) => {
  const workspaceId = new URL(request.url).searchParams.get('workspaceId') as string;
  const { selectedOrganization } = useOrganizationStore.getState();

  if (!selectedOrganization?.permissions) {
    console.error('No selected organization or permissions found');
    return [];
  }

  const allowedConnectorIds =
    selectedOrganization.permissions.organization_available_connectors?.split(',') ?? [];

  const connectors = await ConnectorsService.getAvailableConnectors(workspaceId);

  return connectors.filter((connector) => allowedConnectorIds.includes(connector.id));
};
